<template>
  <div class="app-content text-center">
    <h3>loading..</h3>
  </div>
</template>

<script>
import Amplify, { Auth } from "aws-amplify";
import awsconfig from '../aws-exports'
Amplify.configure(awsconfig)

import axios from 'axios';
export default {
  async mounted() { 
    Auth.currentAuthenticatedUser().then((data) => {
      this.$store.commit('user/setUserOuth', data.user)
      axios
      .get(process.env.VUE_APP_API + "/users/callback", {headers: {'Authorization': 'Bearer ' + data.signInUserSession.accessToken.jwtToken}})
      .then(result => {
        this.$store.commit('user/setUser', result.data)
        this.$store.commit('user/setMemberInfo', result.data)
        if(result.data.first_name != null){
          this.$router.push('/mypage')
        }else{
          this.$router.push('/createuser')
        }              
      }).catch(() => {
        this.$router.push('/')
      })
    })
    .catch(() => {
      this.$router.push('/')
    })
  },
}
</script>
<style scoped lang="scss">
</style>
